import cx from 'classnames';
import { forwardRef } from 'react';

import styles from './TextArea.module.scss';
import usePresenter from './TextArea.presenter';
import type { TextAreaProps } from './TextArea.types';

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((props: TextAreaProps, ref) => {
  const {
    value,
    onInputChanged,
    disabled,
    invalid,
    required,
    otherTextAreaProps,
    variantProps,
  } = usePresenter(props);

  return (
    <textarea
      {...otherTextAreaProps}
      className={cx(styles.textArea, {
        [styles.error]: invalid, // to apply styles for error state to parent div
      }, props.className)}
      ref={ref}
      aria-invalid={invalid}
      value={value || ''}
      onChange={onInputChanged}
      disabled={disabled}
      required={required}
      id={props.id}
      {...variantProps}
    />
  );
});

export default TextArea;